
export default {
  state: {
    editedCavite: null,
    editedCaviteGeometrieAction: null,
  },
  mutations: {
    setEditedCavite(state, data) {
      state.editedCavite = data;
      state.editedCaviteGeometrieAction = null;
    },
    updateGeometryAction(state, ga) {
      state.editedCaviteGeometrieAction = ga;
    }
  }
};
